<template>
  <div id="ClientPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-12">
        <h1 class="title">
          CLIENT MANAGER
        </h1>
        <h1
          v-if="display_list && display_list.length > 0"
          class="subtitle is-6"
        >
          Total {{ display_list.length }} rows founds
        </h1>
      </div>
      <div class="column is-12">
        <b-field>
          <b-input
            placeholder="Search by Client Name..."
            type="search"
            icon="magnify"
            icon-clickable
            @input="filterClientList"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <div class="container">
      <div v-if="display_list">
        <b-table striped hoverable :data="display_list">
          <template slot-scope="props">
            <b-table-column field="full_name" label="Client Name" sortable>
              {{ props.row.full_name }} ( {{ props.row.nick_name }} )
            </b-table-column>

            <b-table-column field="dob" label="Date of Birth" sortable>
              {{ props.row.dob | birthdateformatter }}
            </b-table-column>

            <b-table-column field="dob" label="Age" centered>
              {{ props.row.dob | yearolds }}
            </b-table-column>

            <b-table-column field="gender" label="Gender" sortable>
              <b-tag v-if="props.row.gender === 'M'" type="is-info">
                <b>Male</b>
              </b-tag>
              <b-tag v-else-if="props.row.gender === 'F'" type="is-danger">
                <b>Female</b>
              </b-tag>
              <b-tag v-else type="is-info">
                Others
              </b-tag>
            </b-table-column>

            <b-table-column field="career" label="Career">
              {{ props.row.career }}
            </b-table-column>

            <b-table-column field="income" label="Income" sortable>
              {{ props.row.income | thousand }}
            </b-table-column>

            <b-table-column field="family.child" label="Kid(s)" centered>
              {{ props.row.family.child ? props.row.family.child.length : "-" }}
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon
                    size="is-large"
                    type="is-primary"
                    icon="emoticon-sad-outline"
                  />
                </p>
                <p>No any user here!.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
      <div v-else>
        <section class="hero is-medium">
          <div class="hero-body">
            <div class="container">
              <h2 class="title is-4">
                Loading...
              </h2>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Helpers from "@/utils/Helper";
import ClientApi from "@/services/ClientApi";
import AlertManager from "@/utils/AlertManager";

export default {
  name: "ClientPage",
  computed: mapState(["user_profile"]),
  data() {
    return {
      display_list: null,
      client_list: null
    };
  },
  filters: {
    yearolds: function(value) {
      if (!value) return "";
      return Helpers.ageCalculator(value);
    },
    thousand: function(value) {
      if (!value) return "";
      return Helpers.thousandSeparatorFormat(value);
    },
    dateformatter: function(value) {
      if (!value) return "";
      return Helpers.dateFormatterWithTime(value);
    },
    birthdateformatter: function(value) {
      if (!value) return "";
      return Helpers.dateFormatter(value);
    }
  },
  methods: {
    filterClientList: function(value) {
      const lowercase_value = value.toLowerCase();
      let filtered = this.client_list.filter(client => {
        return (
          (client.full_name &&
            client.full_name.toLowerCase().includes(lowercase_value)) ||
          (client.nick_name &&
            client.nick_name.toLowerCase().includes(lowercase_value))
        );
      });
      this.display_list = filtered;
    },
    requestGetClientList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await ClientApi.requestClientList();
      loadingComponent.close();
      if (response.status) {
        this.client_list = response.payload;
        this.display_list = response.payload.reverse();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    }
  },
  async beforeMount() {
    await this.requestGetClientList();
  }
};
</script>

<style></style>
